var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('div',{staticClass:"container-fluid"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_vm._m(0),_c('create-user-form')],1)])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header text-center"},[_c('h4',{staticClass:"title"},[_vm._v("Create New User")])])
}]

export { render, staticRenderFns }